<template>
  <q-card :style="`width: 280px; min-height: 200px; margin-left: ${
  marginx}px !important; margin-right: ${-marginx}px !important; margin-bottom: ${
  -marginy}px !important; margin-top: ${marginy}px !important;`">
    <!-- <q-card-section class="row items-center">
      <div class="text-h6">Редактирование контакта</div>
      <q-space />
      <q-btn icon="close" flat round dense v-close-popup />
    </q-card-section> -->

    <!-- <q-separator /> -->

    <div v-if="loading" style="text-align: center; margin-top: 50px; margin-bottom: 50px; width: 100%;">
      <q-spinner-dots
        color="primary"
        size="2em"
      />
    </div>

    <q-card-section v-else style="min-height: 25vh; opacity: 0.9;" class="full-width">
      <q-input
        outlined
        dense
        ref="person_name_input"
        color="primary"
        clearable
        clear-icon="arrow_back"
        class="full-width thin-input"
        v-model="personName"
        hide-bottom-space
        :placeholder="$t('name_short')"
        autofocus
        style="margin-bottom: 3px;"
        debounce="100"
        @clear="personName = ''"
      />
      <q-input
        outlined
        dense
        clearable
        clear-icon="arrow_back"
        ref="person_pos_input"
        color="primary"
        class="full-width thin-input"
        v-model="personPosition"
        hide-bottom-space
        :placeholder="$t('position')"
        style="margin-bottom: 3px;"
        debounce="100"
        @clear="personPosition = ''"
      />
      <q-input
        outlined
        dense
        multiline
        autogrow
        clear-icon="arrow_back"
        ref="person_contact_input"
        color="primary"
        class="full-width thin-input-autogrow"
        v-model="personContacts"
        hide-bottom-space
        style="margin-bottom: 3px;"
        :placeholder="$t('contact_info')"
        debounce="100"
        @clear="personContacts = ''"
      />

      <address-selector v-model="AddressModel" @chainSelected="updateChain" :use-required="true" :larger="true" :show-clear="true" />

      <div class="row full-width">
        <!-- tags horizontal list -->
        <div :style="`margin-top: -2px;`" class="row full-width">
          <q-btn
            class="q-my-none q-pa-none"
            flat
            dense
            color="grey-7"
            :aria-label="$t('save')"
            :icon="checkIcon"
            size="11px"
            @click="performAction"
          >
            <q-tooltip :delay="300" anchor="top middle" self="center middle">
              {{ $t('save') }}
            </q-tooltip>
          </q-btn>
          <q-btn
            class="q-my-none q-pa-none"
            flat
            dense
            v-close-popup
            color="grey-7"
            :aria-label="$t('cancel')"
            icon="arrow_back"
            size="11px"
          >
            <q-tooltip :delay="300" anchor="top middle" self="center middle">
              {{ $t('cancel') }}
            </q-tooltip>
          </q-btn>
          
          <q-btn
            class="q-my-none q-pa-none"
            flat
            dense
            color="grey-7"
            :aria-label="$t('tags')"
            :icon="poundIcon"
            size="11px"
            @click="selectorModel = true"
          >
            <q-tooltip :delay="300" anchor="top middle" self="center middle">
              {{ $t('tags') }}
            </q-tooltip>
          </q-btn>

          <!-- <div
            @click="selectorModel = true" class="cursor-pointer q-mr-xs text-bold text-grey-8"
            style="margin-top: 0px; font-size: 18px !important;">#
          </div> -->
            <div class="row no-wrap" v-for="(tag, ri) in tagsModel" :key="ri" style="float: left; margin-right: 5px; font-size: 14px !important;">
              <div class="q-my-auto">{{ tag.Name.toLowerCase() }}</div>
              <q-btn
                class="q-pa-none q-ma-none"
                flat
                dense
                :aria-label="$t('remove')"
                icon="close"
                size="sm"
                @click="() => { tagsModel = tagsModel.filter((el, index) => index != ri) }"
              />
            </div>
        </div>

        <q-select
          :label-slot="false"
          :bottom-slots="false"
          flat dense outlined
          ref="tags_field"
          class="no-select-border q-mb-xs"
          label=""
          v-model="tagsModel"
          use-input
          hide-bottom-space
          fill-input
          multiple
          autofocus
          option-label="Name"
          option-value="Id"
          @input-value="inputFilter"
          @new-value="addTextTag"
          :style="'max-width: 40vw; max-height: 0; overflow: hidden;'"
          input-debounce="500"
          :hide-dropdown-icon="true"
        >
          <q-menu fit no-focus v-model="selectorModel">
            <q-input
              outlined
              dense
              ref="tag_search_input"
              color="white"
              class="full-width thin-input q-my-auto"
              v-model="filter_string"
              hide-bottom-space
              :placeholder="$t('search_by_tags')"
              debounce="100"
            />
            <tag-selector
              :filter_string="filter_string"
              v-model="tagsModel"
            />
          </q-menu>
        </q-select>
      </div>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
// import TagSelector from "@/components/common/aux-selector/TagSelector.vue";
import AddressSelector from '@/components/common/address-selector/AddressSelector.vue';
import { CommonEntity } from "@/models/interfaces/common";
import {
  ParameterInstanceCreateContainer,
} from "@/models/interfaces/entity-settings/parameters/parameters";
import { reactive } from "vue";
import { auxStore } from "@/store/auxillary";
import { TagContainer } from "@/models/interfaces/tags/tag-models";
import { BaseListItem } from "../common/base-list/interfaces/ListTypes";
import { PersonEditRequest } from "@/models/interfaces/http/common.http.request";
import { AddressInputContainer } from "@/models/interfaces/entity-settings";
import { mdiCheckCircleOutline, mdiPound } from '@quasar/extras/mdi-v7'

@Component({
  name: "PersonEditDialog",
  components: { AddressSelector },
})
export default class PersonEditDialog extends Vue {
  // model data
  @Prop({ default: 0 })
  entityId!: any;
  @Prop({ default: 0 })
  marginx!: number
  @Prop({ default: 0 })
  marginy!: number
  @Prop({ default: undefined })
  srcElement!: BaseListItem;
  @Emit("selectorClosed") emitSelectorClosed(arg: any) {
    return arg;
  }
  @Emit("refreshNeeded") emitTableRefresh(arg: any) {
    return arg;
  }

  poundIcon = mdiPound
  checkIcon = mdiCheckCircleOutline

  // store for search functions
  auxstore: any | undefined = undefined;

  // tags
  tags: any[] = [];
  system_tags: CommonEntity[] = [];
  filter_string: string = "";

  loading: boolean = false;

  selectorModel: boolean = false;
  selectedAddressContainer?: AddressInputContainer = undefined;
  personName: string = "";
  personPosition: string = "";
  personContacts: string = "";

  tempTagStatus: any = undefined;
  AddressModel: CommonEntity = reactive({
    Id: 0,
    Name: ''
  });

  parameterContainer: ParameterInstanceCreateContainer | undefined = undefined;
  parametersList: ParameterInstanceCreateContainer[] = [];

  async created() {
    this.loading = true;
    this.auxstore = auxStore();

    if (this.auxstore) {
      this.system_tags = reactive(
        (await this.auxstore.getTagContainer()).data as TagContainer
      ).AllSystemTags;
    }

    this.getPersonInfo();
    this.loading = false;
  }

  inputFilter(val: string) {
      if (val) {
        this.selectorModel = true
        this.filter_string = val
      } else {
        // if previous was just one letter then clear
        // if (this.filter_string.length === 1) {
          this.selectorModel = false
        // } else {
        //   // else restore input value
        //   const that = this
        //   setTimeout(() => {
        //     if (!that.$refs.tags_field) { return }
        //     // @ts-ignore
        //     that.$refs.tags_field.updateInputValue(this.filter_string, true)
        //     // @ts-ignore
        //     that.$refs.tags_field.focus()
        //   }, 100)
        // }
      }
    }

  // tags model
  get tagsModel(): any[] {
    return this.tags;
  }

  set tagsModel(val: any[]) {
    this.tags = val;
  }

  updateChain(val: any) {
    if (val.correct) {
      this.selectedAddressContainer = val.request;
    } else {
      this.selectedAddressContainer = undefined
    }
  }

  // precheck and perform
  async performAction() {
    if (!this.selectedAddressContainer || !this.entityId.personId || !this.personName || !this.personContacts) {
      alert(this.$t('not_all_data_filled'));
      return;
    }
    if (this.auxstore && this.selectedAddressContainer) {
      const req: PersonEditRequest = {
        PersonId: this.entityId.personId,
        Name: this.personName,
        Post: this.personPosition,
        Contacts: this.personContacts,
        InputContainer: this.selectedAddressContainer,
        Tags: this.tagsModel.map(el => el.Name)
      }
      await this.auxstore.changePersonInfo(req)
      this.emitTableRefresh(undefined);
    }
  }

  // tags actions
  addTextTag(val: string, done: any) {
    const found_el = this.system_tags.find((el) => el.Name.trim() === val);
    this.filter_string = "";
    if (found_el) {
      done(found_el, "add-unique");
    } else {
      done(val, "add-unique");
    }
  }

  async getPersonInfo() {
    if (this.auxstore) {
      const resp = (await this.auxstore.getPersonInfo(this.entityId.personId)).data
      console.log(resp)
      this.personName = resp.Name
      this.personPosition = resp.Post
      this.personContacts = resp.Contacts
      this.tags = reactive(resp.Tags)
      this.AddressModel = reactive({
        Id: 0,
        Name: resp.AddressChain.map((el: any) => el.Name).join(',')
      })
    }
  }

  async mounted() {
    
  }
}
</script>

<style lang="scss">
.minw-selector {
  font-size: small !important;
  min-width: fit-content;
}
</style>
